import SashiDo from 'lib/SashiDo';
import AccountManager from 'lib/AccountManager';
import moment from 'moment';
import history from 'dashboard/history';
import Button from 'components/Button/Button.react';
import FlowView from 'components/FlowView/FlowView.react';

import validateEmailFormat      from 'lib/validateEmailFormat';
import Field                    from 'components/Field/Field.react';
import Fieldset                 from 'components/Fieldset/Fieldset.react';
import FormButton               from 'components/FormButton/FormButton.react';
import FormModal                from 'components/FormModal/FormModal.react';
import FormTable                from 'components/FormTable/FormTable.react';
import KeyField                 from 'components/KeyField/KeyField.react';
import Label                    from 'components/Label/Label.react';
import Modal                    from 'components/Modal/Modal.react';
import React, { Component }     from 'react';
import PreLoader                from 'components/PreLoader/PreLoader.react';
import renderFlowFooterChanges  from 'lib/renderFlowFooterChanges';
import styles                   from 'dashboard/Settings/Settings.scss';
import settingsStyles           from 'dashboard/Settings/Settings.scss';
import TextInput                from 'components/TextInput/TextInput.react';
import Toolbar                  from 'components/Toolbar/Toolbar.react';
import { dateStringUTC }        from 'lib/DateUtils';
import UploadAvatarOrIcon       from 'components/UploadAvatarOrIcon/UploadAvatarOrIcon.react';
import Notification             from 'components/Notification/Notification.react';

export default class UpdateDPO extends Component {
  constructor(props) {
    super();

    const info = props.currentCustomer.info;

    this.state = {
      loading: false,
      note: null,
      dpo: info.meta_data && info.meta_data.dpo ? info.meta_data.dpo : {},
    };
  }

  onCloseClick() {
    history.push(`/account/legal`);
  }

  changeAvatar(image) {
    AccountManager.changeAvatar(image);
  }

  renderForm({changes, fields, setField, resetFields}) {
    const { first_name, last_name, email, address, phone } = this.state.dpo;

    let accountInfoFields =
      <Fieldset
        legend='Your Data Protection Officer (DPO)'
        description='Person designated, where applicable, to facilitate compliance with the provisions of the GDPR, which defines the criteria and the conditions under which a data protection officer shall be designated.' >
        <div className={styles.settingsBox}>
          <Notification note={this.state.updateSuccess} close={true} />

          <Field
            label={<Label text='First Name' />}
            input={<TextInput
              value={fields.first_name}
              onChange={setField.bind(this, 'first_name')} />} />

          <Field
            label={<Label text='Last Name' />}
            input={<TextInput
              value={fields.last_name}
              onChange={setField.bind(this, 'last_name')} />} />

          <Field
            label={<Label text='Email' />}
            input={<TextInput
              value={fields.email}
              onChange={setField.bind(this, 'email')} />} />

          <Field
            label={<Label text='Address' />}
            input={<TextInput
              value={fields.address}
              onChange={setField.bind(this, 'address')} />} />

          <Field
            label={<Label text='Phone Number' />}
            input={<TextInput
              value={fields.phone}
              onChange={setField.bind(this, 'phone')} />} />
        </div>
      </Fieldset>

    let classes = [settingsStyles.settings_page, settingsStyles.default];

    return(
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection={'Update Your EU Representative'}>
          <Button value='Go Back' onClick={this.onCloseClick} />
        </Toolbar>
        <div className={[settingsStyles.holder, 'ShowFooter'].join(' ')}>
          <div className={styles.holder}>
            <PreLoader loading={this.state.loading}>
              {accountInfoFields}
            </PreLoader>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { first_name, last_name, email, address, phone } = this.state.dpo;

    let initialFields = {
      first_name: first_name || '',
      last_name : last_name || '',
      email: email || '',
      address: address || '',
      phone: phone || '',
    };

    return <FlowView
      initialFields={initialFields}
      footerContents={({ changes }) => renderFlowFooterChanges(changes, initialFields, pushFieldOptions)}
      onSubmit={({ changes, setField, resetFields }) => {
        const { first_name, last_name, email, address, phone } = changes;

        const obj = {}

        Object.keys(changes).forEach((key) => {
          obj[key] = changes[key]
        })

        return new Promise((resolve, reject) => {
          return SashiDo.updateUserDPO(obj).then((data) =>{
            if(data.error_message) {
              return reject({ error: data.error_message })
            }

            this.setState({ successMessage: { type: 'info', message: 'Your Data Protection Officer was successfully updated!' } });
            return resolve();
          });
        });
      }}

      validate={({ changes, fields }) => {
        if(fields.email !== '' && !validateEmailFormat(fields.email.toLowerCase())) {
          return 'Please add valid Email address!';
        }
      }}
      renderForm={this.renderForm.bind(this)} />;
  }
}

let pushFieldOptions = {
  first_name: {
    friendlyName: 'First name',
    type: 'addition',
  },
  last_name: {
    friendlyName: 'Last name',
    type: 'addition',
  },
  email: {
    friendlyName: 'Email address',
    type: 'addition',
  },
  address: {
    friendlyName: 'Address',
    type: 'addition',
  },
  phone: {
    friendlyName: 'Phone number',
    type: 'addition',
  },
}

